export const supportEndpoints = {
    assignments: {
        list: {
            api: '/api/support/assignments',
            method: 'GET',
            parameter: false
        }
    },
    deliverables: {
        list: {
            api: '/api/support/deliverables',
            method: 'GET',
            parameter: false
        }
    }
};


// WEBPACK FOOTER //
// ./src/endpoints/support.endpoints.ts